import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from './SmsComponent.module.css';
import FireboardUtils from "../../../../util/fireboard-util";

const Row = ({ message, rowIndex, customSms, onHandleSend }) => {
  const [selectedAction, setSelectedAction] = useState(-1);
  return (
    <div className={classNames({ [classes.smsView]: true, [classes.highligthtedAction]: selectedAction === rowIndex })}
      onMouseEnter={() => setSelectedAction(rowIndex)}
      onMouseLeave={() => setSelectedAction(-1)}
    >
      <span className={classes.smsViewText} onClick={() => onHandleSend && onHandleSend(message, customSms)}>{message}</span>
    </div>
  );
};

Row.propTypes = {
  message: PropTypes.string,
  rowIndex: PropTypes.number,
  customSms: PropTypes.object,
  onHandleSend: PropTypes.func,
};

Row.defaultProps = {
  message: '',
  customSms: {},
  onHandleSend: () => { },
};

const CustomSms = props => {
  const { sms, storeInfo, onHandleSend, selectedItem, smsIndex, currency } = props;
  const { description: customDesciption, message: customMessage } = sms || {};
  let message = '' + (customDesciption ? customDesciption : customMessage ? customMessage : '');

  try {
    const { name: storeName, address1: storeAddress, city: storeCity } = storeInfo || {};
    const { checkNumber, unpaidAmount, orders, businessDate, slotName } = selectedItem || {};
    const { orderDate, pickupDate, checkInNote, address1: deliveryAddress, city: deliveryCity } = Array.isArray(orders) ? orders.length > 0 ? orders[0] : {} : {};
    let orderTimeInHrsMins, orderDt, pickupTimeInHrsMins, pickupDt, businessDt;
    if (orderDate) {
      orderTimeInHrsMins = FireboardUtils.getTimeInHrsMins(orderDate);
      orderDt = FireboardUtils.convertedDate(orderDate);
    }
    if (pickupDate) {
      pickupTimeInHrsMins = FireboardUtils.getTimeInHrsMins(pickupDate);
      pickupDt = FireboardUtils.convertedDate(pickupDate);
    }
    if (businessDate) {
      businessDt = FireboardUtils.convertedDate(businessDate);
    }
    const dataObject = {
      StoreName: storeName,
      StoreAddress: storeAddress,
      StoreCity: storeCity,
      CheckNumber: checkNumber,
      BusinessDate: businessDt,
      UnpaidAmount: `${currency}${unpaidAmount}`,
      OrderDate: orderDt,
      PickupDate: pickupDate ? pickupDt : orderDt,
      PickupTime: pickupDate ? pickupTimeInHrsMins : orderTimeInHrsMins,
      DeliverTo: checkInNote,
      DeliveryAddress: deliveryAddress,
      DeliveryCity: deliveryCity,
      CubbySlotName: slotName,
    };

    Object.entries(dataObject).forEach(([key, value]) => {
      message = message.replaceAll(`{{${key}}}`, value || '--');
    });
  } catch (error) {
    console.error(error);
  }

  return <Row message={message} customSms={sms} rowIndex={smsIndex} onHandleSend={onHandleSend} />;
};

export default CustomSms;

CustomSms.propTypes = {
  sms: PropTypes.object,
  storeInfo: PropTypes.object,
  onHandleSend: PropTypes.func,
  selectedItem: PropTypes.object,
  iso2: PropTypes.string,
  currency: PropTypes.string,
  smsIndex: PropTypes.number,
};
